import { render, staticRenderFns } from "./DataInput.vue?vue&type=template&id=2cc462d8&scoped=true&"
import script from "./DataInput.vue?vue&type=script&lang=js&"
export * from "./DataInput.vue?vue&type=script&lang=js&"
import style0 from "./DataInput.vue?vue&type=style&index=0&id=2cc462d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc462d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VApp,VBtn,VDataTable})
